import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPencil = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 18 18"
    {...props}
  >
    <path
      fill="#787887"
      d="M16.344 3.313c.843.843.843 2.187.031 3L6.5 16.25 1.844 17A.723.723 0 0 1 1 16.156l.75-4.656 9.938-9.875a2.113 2.113 0 0 1 2.968 0zM4.75 10.436h1.313v1.5h1.5v1.313l5.28-5.312-2.78-2.782zm-1.187 4.907 2.28-.406.595-.563v-1.312h-1.5v-1.5H3.625l-.562.593-.407 2.281zm11.843-10c.281-.282.281-.75-.031-1.063l-1.687-1.687a.736.736 0 0 0-1.032 0l-1.531 1.531 2.75 2.75z"
    />
  </svg>
);
export default SvgPencil;
